<template>
  <div :style="charts17Style" class="tjsc">
    <div id="echarts17" :style="charts17Style"></div>
    <div class="sumtask">
      停机总时长:
      <span>{{sumtime}}min</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts8",
  props: {
    charts17Style: {
      type: Object,
      default: () => {
        return { width: "100%", height: "184px", position: "relative" };
      }
    },
    echarts17Data: {
      type: Array,
      default: () => {
        return [
          { name: "烟包破损", value: 5 },
          { name: "垛型问题", value: 3 },
          { name: "烟箱问题", value: 8 },
          { name: "机器人吸嘴破损", value: 4.5 },
          { name: "气压不稳", value: 2.5 }
        ];
      }
    },
    sumtime: {
      type: String,
      default: () => {
        return "16";
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.pies();
  },
  methods: {
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts17")
      );
      let option = {
        color: ["#5FEACD", "#F36DA2", "#28A9D8", "#3D55DB", "#F0845E"],
        title: {
          text: "停机时长分析",
          left: 20,
          top: 0,
          textStyle: {
            color: "#0BECF7",
            fontSize: 18
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          top: "middle",
          right: 10,
          top: 65,
          textStyle: {
            color: "#000",
            fontSize: 12
          },
          itemWidth: 6, // 图例图形宽度
          itemHeight: 12, // 图例图形高度
          data: _this.echarts17Data,
          formatter: function(data) {
            for (let index = 0; index < _this.echarts17Data.length; index++) {
              if (_this.echarts17Data[index].name == data) {
                return (
                  _this.echarts17Data[index].value + "min" + " " + " " + data
                );
              }
            }
          }
        },
        series: [
          {
            name: "停机时长分析",
            type: "pie",
            radius: "70%",
            center: ["24%", "55%"],
            label: {
              show: false,
              formatter: "{b}: {d}%"
            },
            data: _this.echarts17Data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              //设置每个饼图之间的边框
              normal: {
                borderWidth: 1,
                // borderColor: "#01142D"
              }
            }
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>
.tjsc{
  margin-top: 35px;
}
.sumtask {
  width: 134px;
  height: 28px;
  position: absolute;
  top: 30px;
  right: 12px;
  font-size: 12px;
  line-height: 28px;
  background-color: #9F8646;
  color: #fff;
  text-align: left;
  padding-left: 10px;
}
.sumtask span {
  color: #fff;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts8.vue